import ability from './ability'

/**
 * Allow navigation when the deepest matched route with ACL meta is permitted.
 * Routes without action+resource (e.g. home, profile) are open to authenticated users.
 */
export const canNavigate = to => {
  const target = [...to.matched].reverse().find(route => route.meta && route.meta.action && route.meta.resource)
  if (!target) {
    return true
  }
  return ability.can(target.meta.action, target.meta.resource)
}

export const _ = undefined
